<template>
    <main class="m-why-quarkino">
        <div class="m-why-quarkino__hero">
            <y-container>
                <y-hero @benefit-content="getBenefitContent" />
            </y-container>
        </div>

        <div
            v-if="benefit"
            id="benefits"
            class="m-why-quarkino__benefit"
        >
            <y-container>
                <y-benefit :content="benefit" />
            </y-container>
        </div>

        <div
            id="components"
            class="m-why-quarkino__components"
        >
            <y-container>
                <y-quarkino-component />
            </y-container>
        </div>

        <div
            id="advantages"
            class="m-why-quarkino__advantage"
        >
            <y-container>
                <y-advantage />
            </y-container>
        </div>

        <div
            id="integration"
            class="m-why-quarkino__integration"
        >
            <y-container>
                <y-solutions />
            </y-container>
        </div>

        <div
            id="security"
            class="m-why-quarkino__security"
        >
            <y-container>
                <y-security />
            </y-container>
        </div>
    </main>
</template>

<script>

    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Component
    import YHero from '@modules/why-quarkino/components/Hero/Hero.vue';
    import YBenefit from '@modules/why-quarkino/components/Benefit/Benefit.vue';
    import YAdvantage from '@modules/why-quarkino/components/Advantage/Advantage.vue';
    import YSolutions from '@modules/why-quarkino/components/Solutions/Index.vue';
    import YSecurity from '@modules/why-quarkino/components/Security/Security.vue';
    import YQuarkinoComponent from '@modules/why-quarkino/components/QuarkinoComponent/QuarkinoComponent.vue';

    export default {

        name: 'WhyQuarkino',

        components: {
            YHero,
            YBenefit,
            YAdvantage,
            YSolutions,
            YSecurity,
            YQuarkinoComponent,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                hero   : null,
                benefit: '',
            };
        },

        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.benefit.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.benefit.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            /**
             * Get benefit content
             *
             * @param {object} value
             */
            getBenefitContent(value) {
                this.benefit = value;
            },
        },

    };
</script>

<style lang="scss" src="../scss/why-quarkino.scss" />

